


import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from "../../store/actions";


const API = process.env.REACT_APP_API;

// Modal simple reutilizable
const Modal = ({ show, onClose, children }) => {
  if (!show) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
    }}>
      <div style={{ background: '#fff', padding: 25, borderRadius: 8, minWidth: 350, maxWidth: 600 }}>
        <button className="btn btn-sm btn-secondary float-end" onClick={onClose}>X</button>
        {children}
      </div>
    </div>
  );
};

const Morosos = (props) => {
  document.title = "Socios  | Morosos - Ges Sindical";

  const breadcrumbItems = [
    { title: "Socios", link: "#" },
    { title: "Morosos", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems('Listado de Morosos', breadcrumbItems);
  }, []);

  const [morosos, setMorosos] = useState([]);
  const [loading, setLoading] = useState(true);

  // Modal pago
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMoroso, setSelectedMoroso] = useState(null);
  const [pagoInfo, setPagoInfo] = useState(null);
  const [pagando, setPagando] = useState(false);
  const [tipoPago, setTipoPago] = useState('total');
  const [montoParcial, setMontoParcial] = useState('');
  const [metodosPago, setMetodosPago] = useState([]);
  const [metodoSeleccionado, setMetodoSeleccionado] = useState('');

  // Cargar morosos
  const fetchMorosos = () => {
    setLoading(true);
    fetch(`${API}/api/members/delinquent`)
      .then(res => res.json())
      .then(data => {
        setMorosos(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchMorosos();
  }, []);

  // Abrir modal de pago y cargar datos
  const handleAbrirPago = async (moroso) => {
    setSelectedMoroso(moroso);
    setPagoInfo(null);
    setModalOpen(true);
    setTipoPago('total');
    setMontoParcial('');
    setMetodoSeleccionado('');

    try {
      // Tomamos el id del responsable (puede ser m.responsableId)
      const res = await fetch(`${API}/api/payments/payment-info/${moroso.responsableId}`);
      const data = await res.json();
      setPagoInfo(data);

      setMontoParcial(data.saldoPendiente || '');

      // Métodos de pago
      const resMetodos = await fetch(`${API}/api/payment-methods`);
      const metodos = await resMetodos.json();
      if (Array.isArray(metodos) && metodos.length > 0) {
        setMetodosPago(metodos.filter(m => m.status !== false));
        setMetodoSeleccionado(metodos[0]._id);
      } else {
        setMetodosPago([]);
        setMetodoSeleccionado('');
        Swal.fire({
          icon: 'warning',
          title: 'No hay métodos de pago configurados',
          text: 'Por favor configure métodos de pago desde el panel de configuración.',
        });
      }
    } catch (error) {
      setPagoInfo({ error: 'No se pudo consultar información de pago.' });
    }
  };

  // Confirmar pago (total o parcial)
  const handlePagar = async (e) => {
    e && e.preventDefault();
    if (!pagoInfo || !selectedMoroso) return;
    if (!metodoSeleccionado) {
      Swal.fire({
        icon: 'warning',
        title: 'Seleccione un método de pago',
        text: 'Debe elegir un método de pago para continuar.',
      });
      return;
    }
    setPagando(true);

    const saldoPendiente = pagoInfo.saldoPendiente ?? (
      pagoInfo.type === 'familiar'
        ? pagoInfo.totalFamilia
        : pagoInfo.finalAmount ?? pagoInfo.baseAmount ?? 0
    );

    let esParcial = tipoPago === 'parcial';
    let monto = esParcial ? Number(montoParcial) : saldoPendiente;

    if (esParcial) {
      if (!monto || isNaN(monto) || monto < 1 || monto >= saldoPendiente) {
        setPagando(false);
        Swal.fire({
          icon: 'warning',
          title: 'Monto inválido',
          text: `Ingrese un monto mayor a 0 y menor que $${saldoPendiente}`,
        });
        return;
      }
    }

    try {
      const res = await fetch(`${API}/api/payments/universal`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          memberId: selectedMoroso.responsableId,
          paymentMethod: metodoSeleccionado,
          isPartial: esParcial,
          amount: monto
        })
      });
      const data = await res.json();
      setPagando(false);

      if (res.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Pago registrado correctamente',
          showConfirmButton: false,
          timer: 1800
        });
        setModalOpen(false);
        fetchMorosos();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al pagar',
          text: data.error || "Ocurrió un problema",
        });
      }
    } catch (error) {
      setPagando(false);
      Swal.fire({
        icon: 'error',
        title: 'Error de red',
        text: 'No se pudo conectar al servidor.',
      });
    }
  };

  // Cambiar estado (activar/desactivar) del socio
  const handleToggleStatus = async (moroso) => {
    Swal.fire({
      title: `¿Seguro que deseas cambiar el estado de "${moroso.responsable}"?`,
      text: "Esto desactivará o reactivará el acceso de este socio.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar estado",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await fetch(`${API}/api/members/${moroso.responsableId}/toggle-status`, {
            method: "PUT"
          });
          const data = await res.json();
          if (res.ok) {
            Swal.fire({
              icon: 'success',
              title: `Socio actualizado`,
              text: `Nuevo estado: ${data.member.membershipStatus}`,
              showConfirmButton: false,
              timer: 1800
            });
            fetchMorosos();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: data.error || "No se pudo cambiar el estado.",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Error de red',
            text: 'No se pudo conectar al servidor.',
          });
        }
      }
    });
  };

  // Formulario dentro del modal
  const renderFormularioPago = () => {
    if (!pagoInfo) return null;

    const montoTotal = pagoInfo.finalAmount ?? pagoInfo.baseAmount ?? 0;
    const saldoPendiente = pagoInfo.saldoPendiente ?? montoTotal;
    const pagadoEsteMes = pagoInfo.pagadoEsteMes ?? 0;

    return (
      <>
        <h4 className="mb-3">Información de Pago</h4>
        <div style={{ marginBottom: '15px' }}>
          <p>
            <strong>Socio:</strong> <strong style={{ fontSize: '18px' }}>{pagoInfo.member?.name}</strong>
          </p>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <strong>Monto Cuota:</strong>
            <span>${pagoInfo.baseAmount}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <strong>Descuento aplicado:</strong>
            <span>${pagoInfo.discountAmount} ({pagoInfo.discountPercentage}%)</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <strong>Nombre(s) del descuento:</strong>
            <span>{pagoInfo.discountNames?.length > 0 ? pagoInfo.discountNames.join(', ') : "Sin descuento"}</span>
          </div>
        </div>
        <div
          style={{
            backgroundColor: '#d3f0fa',
            padding: '16px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center',
          }}
        >
          <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#0066aa' }}>
            Total a pagar: ${montoTotal}
          </p>
          <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#005577' }}>
            Pagado este mes: ${pagadoEsteMes}
          </p>
          <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#005577' }}>
            Saldo pendiente: ${saldoPendiente}
          </p>
        </div>
        {pagoInfo.debe && (
          <form onSubmit={handlePagar}>
            <div className="mb-3">
              <label className="me-3">
                <input
                  type="radio"
                  name="tipoPago"
                  value="total"
                  checked={tipoPago === 'total'}
                  onChange={() => {
                    setTipoPago('total');
                    setMontoParcial(saldoPendiente);
                  }}
                />{" "}
                Pago Total
              </label>
              <label className="ms-3">
                <input
                  type="radio"
                  name="tipoPago"
                  value="parcial"
                  checked={tipoPago === 'parcial'}
                  onChange={() => {
                    setTipoPago('parcial');
                    setMontoParcial('');
                  }}
                />{" "}
                Pago Parcial
              </label>
            </div>
            {tipoPago === 'parcial' && (
              <div className="mb-3">
                <label>Monto a abonar:</label>
                <input
                  type="number"
                  className="form-control"
                  min={1}
                  max={saldoPendiente - 1}
                  value={montoParcial}
                  onChange={(e) => setMontoParcial(e.target.value)}
                  required
                />
              </div>
            )}
            <div className="mb-3">
              <label>Método de Pago:</label>
              <select
                className="form-control"
                value={metodoSeleccionado}
                onChange={(e) => setMetodoSeleccionado(e.target.value)}
                required
              >
                <option value="">Seleccione un método</option>
                {metodosPago.map((m) => (
                  <option key={m._id} value={m._id}>
                    {m.name}
                  </option>
                ))}
              </select>
            </div>
            <button type="submit" className="btn btn-success w-100" disabled={pagando}>
              {pagando ? "Procesando..." : "💸 Realizar Pago"}
            </button>
          </form>
        )}
        {!pagoInfo.debe && (
          <div className="alert alert-success mt-3">
            <strong>✅ ¡Este socio está al día!</strong>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="container mt-4">
      <h2>Listado de Morosos</h2>
      {loading && <p>Cargando...</p>}
      {!loading && (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Responsable</th>
              <th>Documento</th>
              <th>Total Deuda</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {morosos.map(m => (
              <tr key={m.responsableId}>
                <td>{m.responsable}</td>
                <td>{m.documento}</td>
                <td>
                  <span className="font-bold text-blue-800">${m.totalDeuda}</span>
                </td>
                <td>
                  <button className="btn btn-primary btn-sm me-2" onClick={() => handleAbrirPago(m)}>
                    Pagar
                  </button>
                  <button className="btn btn-warning btn-sm" onClick={() => handleToggleStatus(m)}>
                    Desactivar
                  </button>
                </td>
              </tr>
            ))}
            {morosos.length === 0 && (
              <tr>
                <td colSpan={4} className="text-center">No hay morosos.</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {/* Modal de Pago */}
      <Modal show={modalOpen} onClose={() => setModalOpen(false)}>
        {!pagoInfo && <p>Cargando información...</p>}
        {pagoInfo && pagoInfo.error && <p className="text-danger">{pagoInfo.error}</p>}
        {pagoInfo && !pagoInfo.error && renderFormularioPago()}
      </Modal>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(Morosos);
